import type { CarouselConfig } from '@/components/atoms/Carousel';

export const carouselConfig = {
  allowTouchMove: false,
  autoplay: { delay: 7000, pauseOnMouseEnter: true },
  loop: true,
  speed: 1000,
} satisfies CarouselConfig;

export const carouselSwitchIntervalMs = 7000;
export const carouselSliderResetIntervalMs = 50; // 50ms reset

/**
 * WARNING: when chaning this value, make sure to update:
 * - the animation duration in the HeroProgressBar component
 * - tailwind config for the animation: 'animate-grow-width-9s'
 */
export const modernVariantCarouselDurationSec = 9;
